export default {
    'passport':'https://passport.eiceducation.com.cn/api/v1/',
    'mock':'https://kp-ipracticeapi-test.eiceducation.com.cn/api',
}


// WEBPACK FOOTER //
// ./src/api/baseUrl.js